import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, CheckIcon, ArrowRightIcon } from 'lucide-react';
import { trackMetaEvent } from '../utils/metaPixel';
type PackId = 'base' | 'premium';
interface PackItem {
  text: string;
  highlight?: boolean;
}
interface Pack {
  id: PackId;
  name: string;
  tag?: string;
  price: string;
  originalPrice: string;
  href: string;
  includes: PackItem[];
}
const PACKS: Pack[] = [{
  id: 'base',
  name: 'Pack Base',
  price: '$18.900',
  originalPrice: '$34.900',
  href: 'https://pay.hotmart.com/C107152723U',
  includes: [{
    text: 'La Biblia en Cómic completa en PDF'
  }, {
    text: 'BONUS: Sopa de letras de la Biblia'
  }, {
    text: 'BONUS: 25 enseñanzas divinas para niños'
  }, {
    text: 'BONUS: 30 días de oración con versículos del Pentateuco'
  }]
}, {
  id: 'premium',
  name: 'Megapack Premium',
  tag: 'Más elegido',
  price: '$27.990',
  originalPrice: '$59.900',
  href: 'https://totaliadigital.com/cart/50479404122305:1',
  includes: [{
    text: 'Todo lo del Pack Base incluido'
  }, {
    text: '4 películas animadas: David y Goliat, Sansón, Job y Ester',
    highlight: true
  }, {
    text: '65 historias en audio del Antiguo y Nuevo Testamento',
    highlight: true
  }]
}];
export function OfferSection() {
  const [selectedId, setSelectedId] = useState<PackId>('premium');
  const selected = PACKS.find(pack => pack.id === selectedId) ?? PACKS[1];
  return <section id="oferta" className="w-full scroll-mt-4 bg-[#10243D]" data-id="element-93" data-mp="1go2ugd1s5zkv">
      <div className="mx-auto max-w-6xl px-4 py-10 md:py-12" data-id="element-94" data-mp="1ckn23swquldz">
        <h2 className="mx-auto max-w-3xl text-center font-display text-3xl font-bold leading-tight text-white md:text-[40px]" data-id="element-95" data-mp="17mlf4ww761x8">
          Menos de lo que cuesta una pizza. Dura toda su infancia.
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-[15px] text-cream/70" data-id="element-96" data-mp="3sd3tbptj5ay1">
          Elige el pack que quieres llevarte hoy:
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.55
      }} className="mx-auto mt-7 max-w-lg rounded-card border border-gold/70 bg-deep-blue p-5 shadow-2xl md:p-7" data-id="element-97" data-mp="3tuixkq6i9alc">
          <div role="radiogroup" aria-label="Elige tu pack" className="space-y-4" data-id="element-98" data-mp="3ot3f95vppi6n">
            {PACKS.map(pack => {
            const isSelected = pack.id === selectedId;
            return <button key={pack.id} type="button" role="radio" aria-checked={isSelected} onClick={() => setSelectedId(pack.id)} className={`w-full rounded-card border-2 p-5 text-left transition-colors duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold ${isSelected ? 'border-[#75B989] bg-[#75B989]/10' : 'border-white/15 bg-white/5 hover:border-white/30'}`} data-id="element-99" data-mp="315u5thrcahm9">
                  <div className="flex items-start gap-3" data-id="element-100" data-mp="2mk6lnwl4zd3e">
                    <span className={`mt-1 flex h-5 w-5 flex-none items-center justify-center rounded-full border-2 ${isSelected ? 'border-[#75B989] bg-[#75B989]' : 'border-white/40'}`} aria-hidden="true" data-id="element-101" data-mp="2igibd654e3eg">
                      {isSelected && <CheckIcon className="h-3 w-3 text-deep-blue" strokeWidth={4} data-id="element-102" data-mp="3179l48t0rvtd" />}
                    </span>

                    <div className="min-w-0 flex-1" data-id="element-103" data-mp="3f7k9n56uwybd">
                      <div className="flex flex-wrap items-center gap-2" data-id="element-104" data-mp="3a8z9f5rluemx">
                        <span className="font-display text-xl font-bold text-white" data-id="element-105" data-mp="18j1vw64ldbec">
                          {pack.name}
                        </span>
                        {pack.tag && <span className="rounded-full bg-gold px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide text-deep-blue" data-id="element-106" data-mp="1i8toiut4rug6">
                            {pack.tag}
                          </span>}
                      </div>

                      <div className="mt-1 flex items-end gap-2" data-id="element-107" data-mp="plqxsoup4o0h">
                        <span className="text-base text-cream/40 line-through" data-id="element-108" data-mp="uihbx6mxx9j9">
                          {pack.originalPrice}
                        </span>
                        <span className="font-display text-3xl font-black text-[#75B989]" data-id="element-109" data-mp="yn752nq7sa0h">
                          {pack.price}
                        </span>
                      </div>

                      <ul className="mt-3 space-y-1.5" data-id="element-110" data-mp="2a23vo221r79y">
                        {pack.includes.map(item => <li key={item.text} className="flex items-start gap-2" data-id="element-111" data-mp="2p31akko9kn5m">
                            <CheckIcon className={`mt-1 h-3.5 w-3.5 flex-none ${item.highlight ? 'text-gold' : 'text-[#9DD4AA]'}`} aria-hidden="true" data-id="element-112" data-mp="2p55akrj1l20m" />
                            <span className={`text-[14px] leading-snug ${item.highlight ? 'font-semibold text-gold' : 'text-cream/85'}`} data-id="element-113" data-mp="2b9tiyt06nrnx">
                              {item.text}
                            </span>
                          </li>)}
                      </ul>
                    </div>
                  </div>
                </button>;
          })}
          </div>

          <div className="mt-6 flex flex-col items-center" data-id="element-114" data-mp="3moyoe4rp84b8">
            <a href={selected.href} onClick={() => trackMetaEvent('InitiateCheckout', {
            content_name: selected.name,
            value: selected.id === 'premium' ? 27990 : 18900,
            currency: 'ARS'
          })} className="cta-pulse group inline-flex w-full items-center justify-center gap-2 rounded-xl bg-orange px-9 py-4 text-lg font-bold text-white shadow-cta transition-transform duration-200 hover:-translate-y-0.5 hover:brightness-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange md:text-xl" data-id="element-115" data-mp="1k3cji4p68z4y">
              <span className="tracking-wide" data-id="element-116" data-mp="1yrpgn4zzwo11">
                COMPRAR {selected.name.toUpperCase()}
              </span>
              <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-117" data-mp="idh6yb0bq96t" />
            </a>
            <p className="mt-2.5 text-center text-[13px] text-cream/80" data-id="element-118" data-mp="ev9xl0tk6qks">
              Pago único · Sin suscripciones · Acceso de por vida
            </p>
          </div>

          <div className="mt-6 rounded-card border border-[#75B989]/40 bg-[#75B989]/10 px-6 py-5 text-center" data-id="element-119" data-mp="ovahooz95aq1">
            <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-[#75B989]/20" data-id="element-120" data-mp="jx92wg8uzxkd">
              <ShieldCheckIcon className="h-7 w-7 text-[#9DD4AA]" aria-hidden="true" data-id="element-121" data-mp="3scakbaadwt6e" />
            </span>
            <p className="mt-3 font-display text-xl font-bold text-[#B6E1BE]" data-id="element-122" data-mp="3nehh8q4dofac">
              Garantía “Le va a encantar” — 7 días
            </p>
            <p className="mx-auto mt-2 max-w-sm text-[15px] leading-relaxed text-cream/80" data-id="element-123" data-mp="15px61nga5en">
              Descárgala, léesela, pruébala con tus hijos. Si no los atrapa, te
              devolvemos el 100% de tu dinero. Sin preguntas ni vueltas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}